import { styledComponent, Grid, Box, Typography } from '@hermes/web-components'

const primaryFont = 'Poppins'

export const SECTION_WIDTH = '1096px'

export const HomePageLayout = styledComponent(Grid)(({ theme }) => ({
  backgroundColor: '#fff',
  paddingTop: '60px',
  paddingBottom: '65px',
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    paddingTop: '48px'
  }
}))

export const SectionContentPlaceholder = styledComponent(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'lightgray',
  width: '100%'
}))

export const HeroSection = styledComponent('section')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: SECTION_WIDTH,
  textAlign: 'center',
  width: '100%'
}))

export const Section = styledComponent('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: SECTION_WIDTH,
  textAlign: 'center',
  width: '100%',
  padding: '0 16px'
}))

export const SecondarySection = styledComponent(Section)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: '0 24px'
  }
}))

export const H1Title = styledComponent(Typography)(() => ({
  color: '#11245a',
  fontFamily: primaryFont,
  fontSize: '44px',
  fontWeight: 600,
  letterSpacing: '-2px',
  lineHeight: '56px',
  margin: 0
}))

export const H2Title = styledComponent(Typography)(() => ({
  color: '#11245a',
  fontFamily: 'Poppins',
  fontSize: '24px',
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: '32px',
  margin: 0
}))

export const H3Title = styledComponent(Typography)(() => ({
  fontFamily: primaryFont,
  fontWeight: 700,
  fontSize: '30px',
  lineHeight: '40px',
  letterSpacing: '-1px',
  textAlign: 'center',
  color: '#11245A',
  margin: 0
}))

export const H4Title = styledComponent(Typography)(() => ({
  fontFamily: primaryFont,
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32.04px',
  letterSpacing: '-1px',
  textAlign: 'center',
  color: '#11245A',
  margin: 0
}))

export const BodyLarge = styledComponent(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '26px',
  letterSpacing: 0,
  color: '#11245A',
  padding: '0 69px',
  [theme.breakpoints.down('md')]: {
    padding: '0 calc((100vw - 240px) / 2)',
  }
}))

export const BodyMedium = styledComponent(Typography)(() => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '15px',
  lineHeight: '20px',
  letterSpacing: 0,
  color: '#11245A',

  display: '-webkit-box',
  WebkitLineClamp: 5,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}))

export const Specialty = styledComponent('div')(() => ({
  background: '#eef',
  borderRadius: '5px',
  padding: '10px 20px'
}))
